import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./i18n";

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <Routes />
      {/* Single app-wide <Toaster> lives in Routes.jsx; a second one doubles every toast. */}
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
